export function getPaginationInfo(state) {
    return state.upcomingPublications.pagination;
}

export function getTotalsInfo(state) {
    return state.upcomingPublications.totals;
}

export function getUpcomingPublications(state) {
    return state.upcomingPublications.data;
}

export function getUpcomingPublicationAvailableFilters(state) {
    return state.upcomingPublicationFilters.all;
}

export function getUpcomingPublicationFiltersQueryString(state) {
    return state.upcomingPublicationFilters.filterQueryString;
}

export function getUpcomingPublicationSearchText(state) {
    return state.upcomingPublicationFilters.searchText;
}

export function getUpcomingPublicationListSortConfig(state) {
    return {
        sortField: state.upcomingPublicationFilters.sortField,
        sortDirection: state.upcomingPublicationFilters.sortDirection
    };
}

export function isUpcomingPublicationDataLoading(state) {
    return state.upcomingPublications.isFetching;
}

export function isExportingUpcomingPublicationData(state) {
    return state.upcomingPublications.isExporting;
}